"use client";

import { type RefObject, useEffect } from "react";

const useWheelBehavior = (
  scrollRef: RefObject<HTMLDivElement | null>,
  wheelBehavior: "scroll-slider" | "scroll-page",
) => {
  useEffect(() => {
    const container = scrollRef.current;
    if (!container || wheelBehavior === "scroll-page") {
      return;
    }
    const handleWheel = (event: WheelEvent) => {
      const scrollsHorizontallyAlready =
        Math.abs(event.deltaX) >= Math.abs(event.deltaY);
      if (scrollsHorizontallyAlready) {
        return;
      }
      const positionBefore = container.scrollLeft;
      container.scrollLeft += event.deltaY;
      const didScroll = container.scrollLeft !== positionBefore;
      if (didScroll) {
        event.preventDefault();
      }
    };
    container.addEventListener("wheel", handleWheel);
    return () => container.removeEventListener("wheel", handleWheel);
  }, [scrollRef, wheelBehavior]);
};

export default useWheelBehavior;
